import React, { useCallback, useMemo, useState } from 'react';
import { Masthead } from './components/Masthead';
import { ChecklistToolbar } from './components/ChecklistToolbar';
import { ShowRow } from './components/ShowRow';
import { ShareModal } from './components/ShareModal';
import { useWatchlist } from './hooks/useWatchlist';
import { shows } from './data/shows';
import type { ShowFilter } from './types/show';
export function App() {
  const {
    statuses,
    toggle,
    reset,
    seenCount,
    wantCount
  } = useWatchlist();
  const [filter, setFilter] = useState<ShowFilter>('all');
  const [query, setQuery] = useState('');
  const [shareOpen, setShareOpen] = useState(false);
  const closeShare = useCallback(() => setShareOpen(false), []);
  const visible = useMemo(() => {
    const q = query.trim().toLowerCase();
    return shows.filter(show => {
      const status = statuses[show.rank];
      if (filter === 'seen' && status !== 'seen') return false;
      if (filter === 'want' && status !== 'want') return false;
      if (filter === 'unmarked' && status) return false;
      return !q || show.title.toLowerCase().includes(q);
    });
  }, [statuses, filter, query]);
  const handleReset = () => {
    if (window.confirm('Clear all your marks? This can’t be undone.')) reset();
  };
  return <div className="min-h-screen w-full bg-paper text-ink" data-id="element-0" data-mp="5osn3wyp084">
      <main className="mx-auto max-w-6xl px-5 pb-16 md:px-8" data-id="element-1" data-mp="56mnfkhz7n0">
        <Masthead seenCount={seenCount} total={shows.length} data-id="element-2" data-mp="2zlv8x0aavbxp" />

        <ChecklistToolbar seenCount={seenCount} wantCount={wantCount} total={shows.length} filter={filter} onFilterChange={setFilter} query={query} onQueryChange={setQuery} onShare={() => setShareOpen(true)} data-id="element-3" data-mp="33mou3lwcycmw" />

        <section aria-label="Show checklist" className="mt-4" data-id="element-4" data-mp="nvj4pj9gikrb">
          <div className="hidden grid-cols-2 gap-x-16 lg:grid" aria-hidden="true" data-id="element-5" data-mp="nv0wrpdfmi3k">
            {[0, 1].map(col => <div key={col} className="flex justify-end border-b border-ink pb-2 font-sans text-[11px] font-semibold leading-tight text-muted" data-id="element-6" data-mp="swq9d9gaz3tr">
                <span className="w-11 text-center" data-id="element-7" data-mp="3uevs60bsia3m">Seen it</span>
                <span className="w-11 text-center" data-id="element-8" data-mp="d3mil6oj2ni1">Want to</span>
              </div>)}
          </div>

          {visible.length > 0 ? <ul className="gap-x-16 lg:columns-2" data-id="element-9" data-mp="83qdf443gq0w">
              {visible.map(show => <ShowRow key={show.rank} show={show} status={statuses[show.rank]} onToggle={toggle} data-id="element-10" data-mp="3gj1s86szuv2n" />)}
            </ul> : <div className="py-20 text-center" data-id="element-11" data-mp="3lk7m47ye4odr">
              <p className="font-serif text-2xl text-ink" data-id="element-12" data-mp="3liedin47vu34">Nothing here yet</p>
              <p className="mt-2 font-sans text-sm text-muted" data-id="element-13" data-mp="2xtbyzo4vqhcu">
                {query ? `No shows match “${query}”.` : 'Mark a few shows and they’ll appear here.'}
              </p>
            </div>}
        </section>

        <footer className="mt-10 flex flex-col gap-3 border-t border-ink pt-4 font-sans text-sm text-muted sm:flex-row sm:items-center sm:justify-between" data-id="element-14" data-mp="18bya08vkyh24">
          <p data-id="element-15" data-mp="ygmxlx7n9lxj">
            List from The New York Times ·{' '}
            <a href="https://www.nytimes.com/bestTV" target="_blank" rel="noreferrer" className="underline underline-offset-2 hover:text-ink" data-id="element-16" data-mp="13eewxcamcabr">
              nytimes.com/bestTV
            </a>
            . Your marks are saved on this device.
          </p>
          {(seenCount > 0 || wantCount > 0) && <button type="button" onClick={handleReset} className="self-start font-semibold text-muted underline underline-offset-2 hover:text-ink sm:self-auto" data-id="element-17" data-mp="1i5x9f049rmqd">
              Reset my list
            </button>}
        </footer>
      </main>

      <ShareModal open={shareOpen} onClose={closeShare} statuses={statuses} seenCount={seenCount} wantCount={wantCount} total={shows.length} data-id="element-18" data-mp="ano95x7j5zcl" />
    </div>;
}